import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGenerateMovements } from "../../../hooks/useGenerateMovements";
import { useUpdateCartransfer } from "../../../hooks/useUpdateCartransfer";
import { Card, Button, Row, Col } from "antd";
import { LockOutlined, CreditCardOutlined, FileTextOutlined } from "@ant-design/icons";

const CloseDocuments = () => {
  const navigate = useNavigate();
  const cartransfer = useSelector((state) => state.cartransfer);
  const cartransferId = cartransfer.id;
  const generateMovements = useGenerateMovements();
  const updateCartransfer = useUpdateCartransfer();

  const handleMovements = async () => {
    try {
      await generateMovements.mutateAsync(cartransferId);
    } catch (error) {
      console.error('Error generating movements:', error);
    }
  };

  const handleClose = async () => {
    try {
      await updateCartransfer.mutateAsync({
        id: cartransferId,
        data: {
          status: "cerrado",
          closingDate: new Date(),
        },
      });
      // Redirigir a la lista de transferencias después de cerrar
      navigate('/admin/cartransfers/list');
    } catch (error) {
      console.error('Error closing cartransfer:', error);
    }
  };

  return (
    <Card title="Cerrar repertorio" style={{ marginBottom: 16 }}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Button
            size="large"
            icon={<CreditCardOutlined />}
            onClick={() => navigate(`/admin/cartransfers/pay/${cartransferId}`)}
            block
            style={{ 
              marginBottom: 16,
              height: 48,
              fontSize: 16,
              fontWeight: 500,
              backgroundColor: "#1890ff",
              borderColor: "#1890ff",
              color: "#fff"
            }}
          >
            Pagar F23
          </Button>
        </Col>
        <Col span={24}>
          <Button
            size="large"
            icon={<FileTextOutlined />}
            onClick={handleMovements}
            block
            loading={generateMovements.isPending}
            style={{ 
              marginBottom: 16,
              height: 48,
              fontSize: 16,
              fontWeight: 500,
              backgroundColor: "#722ed1",
              borderColor: "#722ed1",
              color: "#fff"
            }}
          >
            Generar F23
          </Button>
        </Col>
        <Col span={24}>
          <Button
            size="large"
            icon={<LockOutlined />}
            onClick={handleClose}
            block
            loading={updateCartransfer.isPending}
            disabled={cartransfer.status === "cerrado"}
            style={{ 
              height: 48,
              fontSize: 16,
              fontWeight: 500,
              backgroundColor: cartransfer.status === "cerrado" ? "#52c41a" : "#fa541c",
              borderColor: cartransfer.status === "cerrado" ? "#52c41a" : "#fa541c",
              color: "#fff"
            }}
          >
            {cartransfer.status === "cerrado"
              ? "Repertorio cerrado"
              : "Cerrar repertorio"}
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default CloseDocuments;
